module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('designated-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd85fad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Designated/UpDesignated.vue
// module id = 2346
// module chunks = 1